import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import PaneAddSignatory from "./add_signatory";
import {ProjectsService} from "../../../service/v1/projects";
import AddDocumentPane from "../../add/add_document";

export default class CCROSignatoriesPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            required_signatories:[],
            attached_signatories:[]
        }
        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    deleteSignatory(d){
        try {
            let signatoryId = d.id
            //TODO Delete Signatory by ID
        }catch (e) {
            console.log(e)
        }
    }

    render() {

        return (<div className={'row'}>




            <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Signatories
                    </span>

                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

             <div className={'row'}>
                <div className={'col col-sm-3'} style={{height: '80vh', padding: 0}}>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', borderBottom: '1px solid #ccc', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Required Signatories
                        </div>
                        <div style={{margin: '16px'}}>
                            {this.state.required_signatories.map((d, i) => {
                                return (<div className={'sub-menu'} onClick={()=>PopDetail.show('New Signatory',
                            <PaneAddSignatory loadData={this.loadData} taskId={this.props.taskId} screen_code={this.props.screen_code} signatory={d} project={this.props.project} key={new Date().getMilliseconds()}/>,42)}
                                             key={i} style={{color:'darkcyan', float:'left',margin:0,width:'100%',padding:'4px'}} title={d.description}>
                                    <span className={'fa fa-times'}/>
                                    {d.designation.name} - {d.locality.name}

                                    <span className={'fa fa-plus'} style={{
                                                float: 'right',
                                                color: '#00984b',
                                                fontSize: '18px'
                                            }}/>
                                </div>)
                            })}

                        </div>
                    </div>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Attached Signatories
                        </div>

                        <div style={{margin: '16px'}}>
                            {this.state.attached_signatories.map((d, i) => {
                                return (<div className={'sub-menu'}
                                             key={i} style={{color:'darkcyan',float:'left',margin:0,width:'100%',padding:'4px'}} title={d.description}>
                                    <span className={'fa fa-check'}/>

                                    <span onClick={() => PopDetail.show(d.design,<div> {d.design} - {d.locality}</div>)}>
                                        {d.design} - {d.locality}
                                    </span>
                                    <span className={'fa fa-trash'} onClick={() => this.deleteSignatory(d)}
                                          style={{float: 'right', color: '#f00', fontSize: '18px'}}/>
                                </div>)
                            })}
                        </div>
                    </div>


                </div>
                <div className={'col col-sm-9'} style={{height: '83vh',borderLeft: '1px solid #ccc'}}>
                    <br/>
                    <table className={'tb'} style={{width:'100%'}}>
                        <thead>
                        <tr>
                            <th style={{width:'50px'}}>#.</th>
                            <th>Fullname</th>
                            <th>Designation</th>
                            <th>Locality</th>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} title={d.description}>
                                <td>
                                    <div style={{width:'14px',float:'left'}}>
                                        {i+1}.
                                    </div>
                                    <input type={'checkbox'} style={{marginLeft:'8px'}}/>
                                </td>
                                <td>
                                    <b style={{color:'darkcyan'}}>{d.fullname}</b>
                                </td>
                                <td>{d.designation}</td>
                                <td>{d.locality}</td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                   {/* <div style={{height: '83vh'}}>

                        <select>
                            <option>- Choose Designation -</option>
                            <option>Village Chairman (VC)</option>
                            <option>Village Executive Officer (VEO)</option>
                            <option>Authorised Land Officer(ALO)</option>
                        </select>
                        <input style={{width:'40%',marginLeft:'4px',padding:'9px'}} placeholder={'Search Here'}/>
                        <button style={{float: 'right', margin: '8px'}} className={'btn submit'} onClick={()=>}>
                            <span className={'fa fa-plus'}/>Add New
                        </button>


                </div>*/}

                </div>


            </div>


        </div>)
    }


    loadData() {
        try {
            Wait.show('Fetching Signatories....')
            ProjectsService.fetchSignatories(this.props.project.id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    required_signatories:r.data.required_signatories,
                    attached_signatories:r.data.attached_signatories
                })
            })
        }catch (e) {
            Wait.dismiss()
        }
    }
}
